import {Link} from 'react-router-dom'
export const Footer = () => {
    return (
        <footer className="flex flex-wrap items-center justify-between gap-4 pt-4">
            <p className="text-base font-medium text-center text-slate-900 dark:text-slate-50 w-full">© 2025 websmileindia All Rights Reserved</p>
        </footer>
    );
};
